import { BillingPanel } from '@orisini/ui/components/billing-panel'
import { useAuth } from '@orisini/ui/context/AuthContext'

/**
 * Halaman langganan orisini.com.
 *
 * Seluruh alur pembayaran ada di <BillingPanel> milik @orisini/ui. Paketnya
 * satu untuk seluruh Orisini, jadi status langganan di setiap baris
 * `me.products` identik — baris pertama cukup sebagai sumbernya. Panel yang
 * sama dipakai SPA produk (mis. pinboss.orisini.com/billing) sehingga user bisa
 * berlangganan tanpa berpindah domain.
 */
export default function BillingPage() {
  const { me } = useAuth()
  const plan = me?.products[0]

  return (
    <BillingPanel
      planCode={plan?.planCode}
      planName={plan?.planName}
      periodEnd={plan?.periodEnd}
      active={plan?.active}
      cancelAtPeriodEnd={plan?.cancelAtPeriodEnd}
    />
  )
}
